import '../../scripts/common.js';

export class FormWebsocket {
  curWebSocket;
  wsConnectInterval;
  pingInterval; // Track the ping timer
  formId;
  onConnectedCallback;

  /**
   * @param {string} formId - The UUID of the application draft.
   * @param {function} onConnectedCallback - Function called when 'connected' event is received.
   */
  constructor(formId, onConnectedCallback, {kind = 'application', browserId = '', onReset = () => {}} = {}) {
    this.kind = kind;
    this.browserId = browserId;
    this.onReset = onReset;
    this.formId = formId;
    this.onConnectedCallback = onConnectedCallback;
    // Try to connect immediately, retry every 5s if fails/disconnects
    this.wsConnectInterval = setInterval(this.createWebSocketConnection.bind(this), 5000);
    this.createWebSocketConnection();
  }

  onWebSocketOpen(ev) {
    // console.log('FormWebsocket open', ev);
    if (this.wsConnectInterval) {
      clearInterval(this.wsConnectInterval);
      this.wsConnectInterval = null;
    }
    // Start Keep-Alive Pings
    this.startPing();
  }

  onWebSocketMessage(ev) {
    try {
      // Handle Pong (optional, just to ignore it)
      if (ev.data === 'pong') return;

      const resp = JSON.parse(ev.data);
      // We only care about the specific connection event
      if (resp.type === 'reset') this.onReset();
      if (resp.type === 'connected') {
        this.onConnectedCallback(resp);
      }
    } catch (e) {
      console.error('FormWebsocket parse error:', e);
    }
  }

  onWebSocketClose(ev) {
    this.curWebSocket = null;
    this.stopPing();

    // Ensure we start trying to reconnect
    if (!this.wsConnectInterval) {
      this.wsConnectInterval = setInterval(this.createWebSocketConnection.bind(this), 5000);
    }
  }

  createWebSocketConnection() {
    if (this.curWebSocket && this.curWebSocket.readyState <= WebSocket.OPEN) return;
    let wsUrl;
    // Logic adapted from _websockets.js to handle local/prod environments
    if (window.location.host.startsWith('127.0.0.1') || window.location.host.startsWith('localhost')) {
      wsUrl = `ws://127.0.0.1:3000/formws?form_id=${this.formId}`;
    } else {
      // Handles https -> wss replacement safely
      const protocol = BACKEND_URL.startsWith('https') ? 'wss' : 'ws';
      const cleanUrl = BACKEND_URL.replace(/^https?:\/\//, '');
      wsUrl = `${protocol}://${cleanUrl}/formws?form_id=${this.formId}`;
    }

    if (this.kind !== 'application') {
      wsUrl += `&kind=${encodeURIComponent(this.kind)}&idd=${encodeURIComponent(this.browserId)}`;
    }
    const ws = new WebSocket(wsUrl);
    ws.onopen = this.onWebSocketOpen.bind(this);
    ws.onmessage = this.onWebSocketMessage.bind(this);
    ws.onclose = this.onWebSocketClose.bind(this);

    this.curWebSocket = ws;
  }

  startPing() {
    this.stopPing();
    this.pingInterval = setInterval(() => {
      if (this.curWebSocket && this.curWebSocket.readyState === WebSocket.OPEN) {
        this.curWebSocket.send('ping');
      }
    }, 30000); // 30 seconds
  }

  stopPing() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
      this.pingInterval = null;
    }
  }

  /**
   * Manually close and stop reconnection attempts (e.g. when form is submitted)
   */
  close() {
    if (this.wsConnectInterval) {
      clearInterval(this.wsConnectInterval);
      this.wsConnectInterval = null;
    }
    this.stopPing();
    if (this.curWebSocket) {
      this.curWebSocket.onclose = null; // Prevent trigger
      this.curWebSocket.close();
      this.curWebSocket = null;
    }
  }
}
